import React from 'react';

import { ROOM_DISPLAY_PHASE } from '../useRoomPhase';
import BetCompletionContent from './BetCompletionContent';
import BetreadyRoomContent from './BetreadyRoomContent';
import BetTimeRoomContent from './BetTimeRoomContent';
import ConfirmedRoomContent from './ConfirmedRoomContent';
import CompletedRoomContent from './CompletedRoomContent';
import InactiveRoomContent from './InactiveRoomContent';
import LockedRoomContent from './LockedRoomContent';
import MemberRoomLayout from './MemberRoomLayout';
import ResultPendingRoomContent from './ResultPendingRoomContent';

function renderPhaseContent({
  responsiveMode,
  roomDisplayPhase,
  statusContentProps,
  viewProps,
}) {
  switch (roomDisplayPhase) {
    case ROOM_DISPLAY_PHASE.INACTIVE:
      return <InactiveRoomContent viewProps={viewProps} />;
    case ROOM_DISPLAY_PHASE.BETREADY:
      return <BetreadyRoomContent viewProps={viewProps} />;
    case ROOM_DISPLAY_PHASE.BET_TIME:
      return (
        <BetTimeRoomContent
          responsiveMode={responsiveMode}
          viewProps={viewProps}
        />
      );
    case ROOM_DISPLAY_PHASE.BET_COMPLETION:
      return (
        <BetCompletionContent
          responsiveMode={responsiveMode}
          viewProps={viewProps}
        />
      );
    case ROOM_DISPLAY_PHASE.LOCKED:
      return (
        <LockedRoomContent
          responsiveMode={responsiveMode}
          viewProps={viewProps}
        />
      );
    case ROOM_DISPLAY_PHASE.RESULT_PENDING:
      return (
        <ResultPendingRoomContent
          pendingResultContent={statusContentProps.pendingResultContent}
          viewProps={viewProps}
        />
      );
    case ROOM_DISPLAY_PHASE.CONFIRMED:
      return (
        <ConfirmedRoomContent
          responsiveMode={responsiveMode}
          resultContent={statusContentProps.resultContent}
          viewProps={viewProps}
        />
      );
    case ROOM_DISPLAY_PHASE.COMPLETED:
      return (
        <CompletedRoomContent
          checkoutContent={statusContentProps.checkoutContent}
          viewProps={viewProps}
        />
      );
    default:
      return <InactiveRoomContent viewProps={viewProps} />;
  }
}

function MemberRoomPhaseContent({
  layoutProps,
  responsiveMode,
  roomDisplayPhase,
  statusContentProps,
  viewProps,
}) {
  const content = renderPhaseContent({
    responsiveMode,
    roomDisplayPhase,
    statusContentProps,
    viewProps,
  });

  return (
    <MemberRoomLayout {...layoutProps} responsiveMode={responsiveMode} roomDisplayPhase={roomDisplayPhase} viewProps={viewProps}>
      {content}
    </MemberRoomLayout>
  );
}

export { default as BetCompletionContent } from './BetCompletionContent';
export { default as BetreadyRoomContent } from './BetreadyRoomContent';
export { default as BetTimeRoomContent } from './BetTimeRoomContent';
export { default as ConfirmedRoomContent } from './ConfirmedRoomContent';
export { default as CompletedRoomContent } from './CompletedRoomContent';
export { default as InactiveRoomContent } from './InactiveRoomContent';
export { default as LockedRoomContent } from './LockedRoomContent';
export { default as PostBetWaitingContent } from './PostBetWaitingContent';
export {
  default as ResultPendingRoomContent,
} from './ResultPendingRoomContent';
export { default as WaitingRoomContent } from './WaitingRoomContent';

export default MemberRoomPhaseContent;
